import { render } from "./BookmarksCrud.vue?vue&type=template&id=20031e6c&scoped=true"
import script from "./BookmarksCrud.vue?vue&type=script&lang=js"
export * from "./BookmarksCrud.vue?vue&type=script&lang=js"

import "./BookmarksCrud.vue?vue&type=style&index=0&id=20031e6c&lang=scss&scoped=true"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20031e6c"]])

export default __exports__